export default function AboutItem() {
  return (
    <div>
      <div>Welcome to AboutItem</div>
    </div>
  );
}
